import React, { useEffect, useState } from "react";
import { Button, Card, CardActions, CardContent, Checkbox, FormControlLabel, Grid, MenuItem, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEdicionSocio } from "../../../../context/socio/use-edicion-socio";
import SelectWithServerData from "../../../../components/Select/SelectWithServerData";
import EndPoints from "../../../../utils/services/EndPoints";
import { DatePicker } from "@mui/x-date-pickers";
import { getUser } from "utils/Common";
import Api from "utils/services/Api";
import SaveActualiza from '@mui/icons-material/SaveAs';
import { NuevoConyugeForm } from "./NuevoConyugeForm";
import dayjs from 'dayjs';
import ReadOnlyTextField from "components/input/ReadOnlyTextField";

const useStyles = makeStyles(() => ({
  cardActions: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

const estadosCiviles = [
  {
    value: 1,
    label: "Soltero"
  },
  {
    value: 2,
    label: "Casado"
  },
  {
    value: 3,
    label: "Divorciado"
  },
  {
    value: 4,
    label: "Unión libre"
  },
  {
    value: 5,
    label: "Viudo"
  }
];

const NuevoSocioForm = ({
  listPersonByEntity,
}) => {
  const { infoSocio, goNextStep, goPreviousStep, } = useEdicionSocio()
  const [fechaNacimiento, setFechaNacimiento] = useState(infoSocio.datosBasicosMs.fechaNacimientoDate ? dayjs(infoSocio.datosBasicosMs.fechaNacimientoDate) : dayjs('15/05/1988'));
  const classes = useStyles();
  const [correoElectronico, setCorreoElectronico] = useState(infoSocio.datosBasicosMs.correoElectronico)
  const [registraConyuge, setRegistraConyuge] = useState(infoSocio.datosBasicosMs.registroConyuge === "S")
  const [person, setPerson] = useState(infoSocio.conyugeMs.codigo)
  const [nivelAcademico, setNivelAcademico] = useState(infoSocio.nivelAcademicoMs.codigo)
  const [profesion, setProfesion] = useState(infoSocio.profesionMs.codigo)

  const onChangeProfesion = (event) => {
    setProfesion(event.target.value)
  };

  useEffect(() => {
    if (infoSocio.conyugeMs)
      setPerson(infoSocio.conyugeMs.codigo)
  }, [infoSocio]);

  const changeCorreo = (event) => {
    setCorreoElectronico(event.target.value);
  };

  const changeNivelAcademico = (event) => {
    setNivelAcademico(event.target.value)
  }

  const actualizaInformacion = () => {
    (async () => {
      if (infoSocio.datosBasicosMs.codigoPersona === person) {
        // generarNotificacion(true,'No puede agregar como conyuge a la misma persona', 2);
        return
      }
      const datosConyuge = {
        personaConyugeMs: {
          codigoPersona: infoSocio.datosBasicosMs.codigoPersona,
          codigoPersonaConyuge: person,
          codigoEntidad: getUser().ifip.codigo
        },
        fechaNacimiento: fechaNacimiento,
        registraConyugeString: registraConyuge ? "S" : "N",
        codigoUsuario: getUser().codigo,
        correoElectronicoString: correoElectronico,
        nivelAcademico: nivelAcademico,
        codigoProfesion: profesion
      };
      Api(EndPoints.addConyuge, "POST", datosConyuge)
        .then((response) => {

        })
        .catch((error) => {
        });
    })();
  };

  return (<>

    <Grid item xs={12} md={12} textAlign="right">
      <Button
        size="large"
        variant="contained"
        onClick={actualizaInformacion}
        startIcon={<SaveActualiza />}
      >
        Actualizar
      </Button>
    </Grid>
    <Grid container item xs={12}>

      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <ReadOnlyTextField
                disabled='true'
                id="numeroIdentificacion"
                label="Identificación"
                value={infoSocio.datosBasicosMs.numeroIdentificacion}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ReadOnlyTextField
                disabled='true'
                id="nombres"
                label="Nombres"
                value={infoSocio.datosBasicosMs.nombres}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ReadOnlyTextField
                disabled='true'
                id="primerApellido"
                label="Apellido Paterno"
                value={infoSocio.datosBasicosMs.primerApellido}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ReadOnlyTextField
                disabled='true'
                id="segundoApellido"
                label="Apellido Materno"
                value={infoSocio.datosBasicosMs.segundoApellido}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ReadOnlyTextField
                disabled='true'
                id="idEstadoCivil"
                label="Estado Civil"
                value={infoSocio.estadoCivilMs.codigo}
                select
              >
                {estadosCiviles.map(option => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </ReadOnlyTextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <SelectWithServerData
                id="idNivelAcademico"
                label="Nivel Academico"
                endpoint={EndPoints.listNivelAcademico}
                value={nivelAcademico}
                onChange={changeNivelAcademico}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <SelectWithServerData
                id="idProfesion"
                label="Profesión"
                endpoint={EndPoints.listProfesion}
                value={profesion}
                onChange={onChangeProfesion}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                variant="outlined"
                id="correoElectronico"
                label="Correo Electronico"
                value={correoElectronico}
                onChange={changeCorreo}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DatePicker
                label="Fecha de nacimiento"
                id="fechaNacimiento"
                value={fechaNacimiento}
                onChange={(newValue) => {
                  setFechaNacimiento(newValue);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                disableFuture
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={registraConyuge}
                    name="registroConyuge"
                    color="primary"
                    onChange={(_, checked) => setRegistraConyuge(checked)}
                  />
                }
                label="Registra Conyuge"
              />
            </Grid>

          </Grid>
          {
            registraConyuge && (
              <NuevoConyugeForm
                setPerson={setPerson}
                datoConyuge={infoSocio.conyugeMs.codigo}>
              </NuevoConyugeForm>
            )
          }
        </CardContent>
        <CardActions
          classes={{
            root: classes.cardActions
          }}
        >
          <Button
            color="primary"
            onClick={goPreviousStep}
          >
            Cancelar
          </Button>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={goNextStep}
          >
            Siguiente
          </Button>
        </CardActions>
      </Card>

    </Grid>
  </>
  );
};

export default NuevoSocioForm;
